import * as React from "react";

const Minus: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-623.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(544.000000, 183.000000)">
                    <polygon points="11.00025 11.00025 6 11.00025 6 13.0005 18 13.0005 18 11.00025 12.99975 11.00025"></polygon>
                    <path d="M12,2.00025 C17.49975,2.00025 21.99975,6.50025 21.99975,12 C21.99975,17.49975 17.49975,21.99975 12,21.99975 C6.50025,21.99975 2.00025,17.49975 2.00025,12 C2.00025,6.50025 6.50025,2.00025 12,2.00025 L12,2.00025 Z M12,0 C5.4,0 0,5.4 0,12 C0,18.6 5.4,24 12,24 C18.6,24 24,18.6 24,12 C24,5.4 18.6,0 12,0 L12,0 L12,0 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Minus);
